import React from 'react';
import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseHandle: React.FC<IProps> = ({ className }) => (
    <div className={className}>
        <svg
            className={className}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        </svg>
        <svg
            className={className}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        </svg>
    </div>
);

export const Handle = styled(BaseHandle)`
    background: #fff;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    svg {
        width: 14px;
        height: 14px;
        position: absolute;
        top: 50%;
        left: 50%;

        :first-of-type {
            transform: translate(-90%, -50%) rotate(180deg);
        }

        :last-of-type {
            transform: translate(-10%, -50%);
        }
    }
`;
